import styled from 'styled-components';

export const StyledWrap = styled.div`
  position: relative;
  border-radius: ${({ theme }) => theme.cardRadius};
`;

export const StyledContent = styled.div`
  opacity: 0.45;
  pointer-events: none;
  user-select: none;
`;

export const StyledBadge = styled.span`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
  padding: 8px 14px;
  border-radius: 18px;
  background: ${({ theme }) => theme.text};
  color: ${({ theme }) => theme.card};
  border: 1px solid ${({ theme }) => theme.border};
  font-family: 'Archivo', sans-serif;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.02em;
  white-space: nowrap;
`;
